import { BaseDto } from "./base.dto"

import * as _ from 'lodash'

import { PagingDto } from "./paging.dto"
import { FileDto } from "./file.dto"
import { TranslationDto } from "./translation.dto"

export class FindByMallId {
  mallId?: string
}

export class MallDto extends BaseDto {
  name?: TranslationDto
  slug?: string
  description?: TranslationDto
  address?: TranslationDto
  logo?: FileDto
  enabled?: boolean
  image?: FileDto
  latitude?: number
  longitude?: number
  mallEnabled?: boolean

  static create({ id, name, description, address, mallEnabled, logo, image }: MallDto) {
    return _.assign(new MallDto(), {
      id: id || null,
      name: name || TranslationDto.create(),
      description: description || TranslationDto.create(),
      address: address || TranslationDto.create(),
      logo: logo || null,
      image: image || null,
      mallEnabled
    })
  }
  static creating() {
    return new MallDto()
  }
}

export class FindMallDto extends PagingDto {
  searchText?: string
  getAll?: boolean = false
}

export class CreateMallDto {
  name: TranslationDto
  description: TranslationDto
  address: TranslationDto
  logoId?: string
  imageId?: string
}

export class UpdateMallDto {
  name?: TranslationDto
  description?: TranslationDto
  address?: TranslationDto
  logoId?: string
  enabled?: boolean
  imageId?: string
  latitude?: number
  longitude?: number
}

export class CreateMallAdminDto {
  fullName: string
  email: string
  password: string
}
